var map = {
	"./Conditional/ComparisonComponent.js": "fc1e",
	"./Conditional/FireOnComponent.js": "0ea1",
	"./Conditional/ToggleComponent.js": "469d",
	"./Debug/LabelComponent.js": "1121",
	"./Debug/PrintObjectComponent.js": "68b3",
	"./Interval/DateTimeComponent.js": "3792",
	"./Interval/ProcessTriggerComponent.js": "cf5f",
	"./NumberAdderComponent.js": "e3e2",
	"./NumberDisplayComponent.js": "dc64",
	"./NumberInputComponent.js": "59c5",
	"./NumberOperationComponent.js": "44e1",
	"./OperationsComponent.js": "338d",
	"./Simulator/AThenBOrResetTriggerComponent.js": "eabb",
	"./Simulator/AThenBTriggerComponent.js": "4264",
	"./Simulator/AUntilBTriggerComponent.js": "3014",
	"./Simulator/AnyArrayCollector.js": "d715",
	"./Simulator/AnyArrayExpander.js": "6522",
	"./Simulator/AnyArrayQueueFIFO.js": "427a",
	"./Simulator/AnyArrayToStream.js": "a9d8",
	"./Simulator/NumberArrayCollector.js": "1da3",
	"./Simulator/NumberArrayToStream.js": "df37",
	"./Simulator/ResetComponent.js": "c8b7",
	"./StatisticsComponent.js": "aff9",
	"./Stats/StatsCompositeComponent.js": "bd1a",
	"./StatsOperationsComponent.js": "f123",
	"./Stocks/StockBreakOutComponent.js": "bcb4",
	"./Stocks/StockDataListComponent.js": "4424",
	"./StringComponent.js": "b502",
	"./Visualization/StockChartComponent.js": "bf68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bbc1";